import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export enum FeatureSettingEnum {
  EvidenceSourceUpload = 'EvidenceSourceUpload',
  GlobalScalingEnabled = 'GlobalScalingEnabled',
  PowerBIReportsEnabled = 'PowerBIReportsEnabled'
}

export interface FeatureSetting {
  featureSettingsKey: string;
  key: string;
  isEnabled: boolean;
}

export interface FeatureSettingsState {
  value: {
    featureSettings: FeatureSetting[];
  };
}

const initialState: FeatureSettingsState = {
  value: {featureSettings: []},
};

const featureSettingsSlice = createSlice({
  name: 'featureSettings',
  initialState,
  reducers: {
    setFeatureSettings(state, action: PayloadAction<FeatureSetting[]>) {
      state.value.featureSettings = action.payload;
    },
    resetFeatureSettings: () => initialState,
  },
  selectors: {
    getFeatureSettings(state) {
      return state?.value?.featureSettings ?? [];
    },
    isFeatureSettingEnabled(state, featureSettingsKey: FeatureSettingEnum) {
      return (
        state?.value?.featureSettings?.find(
          (item: FeatureSetting) => item?.key === featureSettingsKey
        )?.isEnabled ?? false
      );
    },
  },
});

export const {setFeatureSettings, resetFeatureSettings} =
  featureSettingsSlice.actions;
export const {getFeatureSettings, isFeatureSettingEnabled} =
  featureSettingsSlice.selectors;

export default featureSettingsSlice.reducer;
